import React, { useState, useEffect } from 'react';

function BetCreationForm({ isOpen, onClose, onCreateBet, whitelistedUsers, currentUserEmail }) {
  const [description, setDescription] = useState('');
  const [hasExpiry, setHasExpiry] = useState(false);
  const [expiresAt, setExpiresAt] = useState('');
  const [offerRound, setOfferRound] = useState('yes'); // 'yes' or 'no'
  const [selectedUser, setSelectedUser] = useState('');
  const [requiresResponse, setRequiresResponse] = useState(false);
  const [creatorPrediction, setCreatorPrediction] = useState('');
  const [error, setError] = useState('');
  const [placeholder, setPlaceholder] = useState('e.g., England wins the next match');

  const placeholders = [
    "The Monk to become a TD before 2030?",
    "Ireland to get to a WRC semi final?",
    "Gary Gannon to lose his seat in next GE",
    "SF to have lowest first preference votes in Dub Central by election"
  ];

  useEffect(() => {
    if (isOpen) {
      const randomPlaceholder = placeholders[Math.floor(Math.random() * placeholders.length)];
      setPlaceholder(randomPlaceholder);
    }
  }, [isOpen]);

  // Get other users (not current user)
  const otherUsers = whitelistedUsers.filter(u => u.email !== currentUserEmail);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!description.trim()) {
      setError('Please enter what the bet is about.');
      return;
    }

    if (requiresResponse && !creatorPrediction.trim()) {
      setError('Please enter your prediction.');
      return;
    }

    // Determine participants based on "Offer a Round"
    let participants;
    if (offerRound === 'yes') {
      // Include both other users
      participants = otherUsers.map(u => u.email);
    } else {
      // Include only selected user
      if (!selectedUser) {
        setError('Please select a user.');
        return;
      }
      participants = [selectedUser];
    }

    const betData = {
      description,
      participants_emails: participants,
      expires_at: hasExpiry && expiresAt ? expiresAt : null,
      requires_response: requiresResponse,
      creator_prediction: requiresResponse && creatorPrediction ? creatorPrediction : null,
    };

    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/bets/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-User-Email': currentUserEmail
        },
        credentials: 'include',
        body: JSON.stringify(betData),
      });

      if (response.ok) {
        const newBet = await response.json();
        onCreateBet(newBet);
        // Reset form
        setDescription('');
        setHasExpiry(false);
        setExpiresAt('');
        setOfferRound('yes');
        setSelectedUser('');
        setRequiresResponse(false);
        setCreatorPrediction('');
        setError('');
        onClose(); // Close modal
      } else {
        const errorData = await response.json();
        setError(errorData.detail || 'Failed to create pint.');
      }
    } catch (err) {
      setError('Network error or server unavailable.');
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(13, 13, 13, 0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(4px)'
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #3d3127 0%, #2a2018 100%)',
        padding: '30px',
        borderRadius: '4px',
        border: '2px solid #5a4a38',
        boxShadow: '0 12px 32px rgba(0, 0, 0, 0.9), inset 0 1px 0 rgba(255, 255, 255, 0.05)',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '90vh',
        overflow: 'auto',
        color: '#f9f6f0'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #5a4a38', paddingBottom: '15px' }}>
          <h2 style={{ margin: 0, color: '#daa520', textShadow: '0 2px 4px rgba(0, 0, 0, 0.8)' }}>Put a Pint On It</h2>
          <button onClick={onClose} style={{
            background: 'none',
            border: 'none',
            fontSize: '32px',
            cursor: 'pointer',
            color: '#daa520',
            padding: '0',
            lineHeight: '1',
            fontWeight: 'bold'
          }}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          {error && <p style={{ color: '#ff6b6b', marginBottom: '15px', padding: '10px', background: 'rgba(139, 46, 46, 0.3)', borderRadius: '3px', border: '1px solid #8b2e2e' }}>{error}</p>}

          {/* What are you confidently incorrect about? */}
          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="description" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#daa520' }}>
              What are you confidently incorrect about?
            </label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder={placeholder}
              style={{
                width: '100%',
                padding: '10px',
                boxSizing: 'border-box',
                minHeight: '80px',
                fontSize: '14px',
                background: '#2d2317',
                border: '2px solid #5a4a38',
                color: '#f9f6f0',
                borderRadius: '3px'
              }}
              required
            />
          </div>

          {/* Expiry date */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#daa520' }}>
              Expiry date
            </label>
            <div style={{ marginBottom: '10px' }}>
              <input
                type="checkbox"
                id="hasExpiry"
                checked={hasExpiry}
                onChange={(e) => setHasExpiry(e.target.checked)}
              />
              <label htmlFor="hasExpiry" style={{ marginLeft: '8px', color: '#f9f6f0' }}>Yes</label>
            </div>
            {hasExpiry && (
              <input
                type="datetime-local"
                value={expiresAt}
                onChange={(e) => setExpiresAt(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px',
                  boxSizing: 'border-box',
                  background: '#2d2317',
                  border: '2px solid #5a4a38',
                  color: '#f9f6f0',
                  borderRadius: '3px'
                }}
              />
            )}
          </div>

          {/* Offer a Round? */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#daa520' }}>
              Offer a Round?
            </label>
            <div style={{ marginBottom: '10px' }}>
              <input
                type="radio"
                id="roundYes"
                name="offerRound"
                value="yes"
                checked={offerRound === 'yes'}
                onChange={(e) => setOfferRound(e.target.value)}
              />
              <label htmlFor="roundYes" style={{ marginLeft: '8px', marginRight: '20px', color: '#f9f6f0' }}>
                Yes (both users)
              </label>

              <input
                type="radio"
                id="roundNo"
                name="offerRound"
                value="no"
                checked={offerRound === 'no'}
                onChange={(e) => setOfferRound(e.target.value)}
              />
              <label htmlFor="roundNo" style={{ marginLeft: '8px', color: '#f9f6f0' }}>
                No (select one)
              </label>
            </div>

            {offerRound === 'no' && (
              <select
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px',
                  boxSizing: 'border-box',
                  background: '#2d2317',
                  border: '2px solid #5a4a38',
                  color: '#f9f6f0',
                  borderRadius: '3px'
                }}
              >
                <option value="">-- Select User --</option>
                {otherUsers.map(user => (
                  <option key={user.email} value={user.email}>
                    {user.name}
                  </option>
                ))}
              </select>
            )}
          </div>

          {/* Opinions are like arseholes */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ marginBottom: '10px' }}>
              <input
                type="checkbox"
                id="requiresResponse"
                checked={requiresResponse}
                onChange={(e) => setRequiresResponse(e.target.checked)}
              />
              <label htmlFor="requiresResponse" style={{ marginLeft: '8px', color: '#f9f6f0' }}>
                Opinions are like arseholes, everyone has one?
              </label>
            </div>
            {requiresResponse && (
              <div>
                <label htmlFor="creatorPrediction" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#daa520' }}>
                  Your prediction:
                </label>
                <input
                  type="text"
                  id="creatorPrediction"
                  value={creatorPrediction}
                  onChange={(e) => setCreatorPrediction(e.target.value)}
                  placeholder="e.g., 25.5"
                  style={{
                    width: '100%',
                    padding: '8px',
                    boxSizing: 'border-box',
                    background: '#2d2317',
                    border: '2px solid #5a4a38',
                    color: '#f9f6f0',
                    borderRadius: '3px'
                  }}
                />
              </div>
            )}
          </div>

          {/* Submit Button */}
          <button type="submit" style={{
            width: '100%',
            padding: '12px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            background: 'linear-gradient(145deg, #b8860b, #cd7f32)',
            color: '#1a1612',
            border: '2px solid #daa520',
            borderRadius: '3px',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.6)'
          }}>
            Place the Bet
          </button>
        </form>
      </div>
    </div>
  );
}

export default BetCreationForm;
